<template>
    <div class="bg-slate-50 h-[100vh] overflow-y-auto">
        <div class="container mx-auto mt-10 bg-white shadow p-8 rounded-xl">
            <h1 class="text-2xl font-bold mb-6">Résumé des réponses</h1>
            <div class="grid grid-cols-3 gap-10" v-if="data">
                <div class="col-span-2">
                    <div class="grid grid-cols-2 gap-10">
                        <div class="p-4 border rounded-xl flex items-center justify-center">
                            <div class="text-center">
                                <div class="text-3xl font-bold">{{ data.length }}</div>
                                <div class="text-xl font-light">{{ data.length > 1 ? 'Réponses' : 'Réponse' }}</div>
                            </div>
                        </div>
                        <div class="p-4 border rounded-xl">
                            <canvas id="utile_immo"></canvas>
                        </div>
                        <div class="p-4 border rounded-xl">
                            <canvas id="utile_entreprise"></canvas>
                        </div>
                        <div class="p-4 border rounded-xl">
                            <canvas id="utile_client"></canvas>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="h-[300px] border rounded-xl overflow-y-auto">
                        <h1 class="text-xl font-bold p-2 border-b">Adresses email</h1>
                        <div v-for="(email, emailIndex) in data.map((item) => item.email)" :key="'email-' + emailIndex" v-if="email" class="border-b p-2">
                            {{ email }}
                        </div>
                    </div>
                    <div class="mt-10">
                        <div class="h-[300px] border rounded-xl overflow-y-auto">
                            <h1 class="text-xl font-bold p-2 border-b">Idées supplémentaires</h1>
                            <div v-for="(more, moreIndex) in data.map((item) => item.more_info)" :key="'more-' + moreIndex">
                                <div v-if="more" class="border-b p-2">
                                    {{ more }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            data: null
        }
    },
    methods: {
        async getData() {
            let response = await axios.get('https://x8ki-letl-twmt.n7.xano.io/api:0NC1WJQ2/avis')
            this.data = response.data
        },

        barsFromKey(key) {
            let labels = []
            let values = []
            if (this.data) {
                this.data.forEach((item) => {
                    if (!labels.find((label) => label == item[key])) {
                        labels.push(item[key])
                    }
                })

                labels.forEach((label) => {
                    let items = this.data.filter((d) => d[key] == label)
                    values.push(items.length)
                })
            }

            return {
                labels: labels,
                values: values
            }
        },

        makeChart(id, key, title) {
            let data = this.barsFromKey(key)

            const ctx = document.getElementById(id);

            new Chart(ctx, {
                type: 'bar',
                data: {
                labels: data.labels,
                datasets: [{
                    label: '# of Votes',
                    data: data.values,
                    borderWidth: 1
                }]
                },
                options: {
                    scales: {
                        y: {
                        beginAtZero: true
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: title
                        }
                    }
                }
            });
        }
    },
    async mounted () {
        await this.getData()

        this.makeChart('utile_immo', 'utile_immo', "Selon vous, un logiciel comme celui-ci pourrait-il apporter une réelle valeur dans le secteur immobilier ?")
        this.makeChart('utile_entreprise', 'utile_entreprise', "À quel point ce concept serait-il utile dans votre entreprise ?")
        this.makeChart('utile_client', 'utile_client', "Pensez-vous que vos clients apprécieront ce format interactif pour découvrir les biens ?")
    },
}
</script>

<style lang="scss" scoped>

</style>